import apiClient from "./client";

export function pullESRIFeatures(serviceUrl, layerId, whereClause) {
  return apiClient.post("/esri/pull", {
    serviceUrl,
    layerId,
    whereClause,
  });
}

export function pushESRIFeature(serviceUrl, layerId, feature, apiKey) {
  return apiClient.post("/esri/push", {
    serviceUrl,
    layerId,
    feature,
    apiKey,
  });
}

export function updateESRIFeature(serviceUrl, layerId, objectId, attributes, apiKey) {
  return apiClient.post("/esri/update", {
    serviceUrl,
    layerId,
    objectId,
    attributes,
    apiKey,
  });
}

export function syncESRIRegion(regionName) {
  return apiClient.post("/esri/sync/region", {
    regionName: regionName || "NorthClare", // Default to NorthClare for backward compatibility
  });
}

// Manual push of every Finding under an Inspection to whichever ESRI
// Feature Layer the customer has configured for "Finding" under
// Customer Settings → ESRI. One click on the Inspection → one ESRI
// record per Finding. Returns { total, succeeded, failed, firstError }.
export function pushInspectionFindingsToEsri(inspectionId) {
  return apiClient.post(
    `/esri/inspection/${encodeURIComponent(inspectionId)}/push-findings`
  );
}

